export function tablePaginationOptions(isMobile: boolean): number[] {
  if (isMobile) {
    return [7, 15, 25, 50, -1];
  }
  return [10, 25, 50, 100, -1];
}
